import { useTranslation } from 'react-i18next'

import { IPlanMenuControlOrdersRequest } from 'core/api/dto/PlanMenuControlDto'
import { useSearchParams } from 'react-router-dom'

import AppBtn, { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import { useGetPlanMenuControlDimensionDetailQuery } from 'core/api/PlanMenuControlApi'

import { IPlanMenuCloseOrderDetailDto } from 'core/api/dto/PlanMenuCloseDto'
import moment from 'moment'
import './DishItemBlock.scss'
import { FrozeDetailInfo } from 'components/frozeDetail/FrozeDetailInfo'
import { FrozeDetailPhotoBlock } from 'components/frozeDetail/FrozeDetailPhotoBlock'

export interface IMilletBlockProps {
  pageParams: IPlanMenuControlOrdersRequest | null
  onClick: () => void
  orderDetail?: IPlanMenuCloseOrderDetailDto
}

export const AddDishBlock = ({
  pageParams,
  onClick,
  orderDetail,
}: IMilletBlockProps) => {
  const { t } = useTranslation()

  const [searchParams] = useSearchParams()

  const currentDish = searchParams.get('dish')
  const currentDimensionId = searchParams.get('dimension')

  const name = orderDetail?.orderLines.find(
    (item) => Number(currentDish || 0) === item.id,
  )

  const { data: currentDimension } = useGetPlanMenuControlDimensionDetailQuery(
    { id: Number(currentDimensionId) },
    { skip: !currentDimensionId },
  )

  return (
    <div>
      <div className="title-text">{`Замер от ${moment(
        currentDimension?.dimensionDatetime,
      ).format('DD.MM.YYYY HH:mm')}`}</div>
      <div className="title-dish">{name?.dish.name}</div>
      <div className={`millet-block mb-20`} onClick={onClick}>
        <AppBtn sized={AppBtnSize.fullWidth} color={AppBtnColor.lightViolet}>
          <div>
            <i className="an-ico an-ico-exchange" />
            <span>{t('Выбрать блюдо для замены')}</span>
          </div>
        </AppBtn>
        <div className="text-info">
          <i className="an-ico an-ico-info-circle " />
          <span>{t('Выберите необходимое блюдо для замены из списка')}</span>
        </div>
      </div>
      <div className="title-dish">Информация о замере</div>
      {currentDimension && (
        <div className="froze-detail-wrap">
          <FrozeDetailInfo dimensionItem={currentDimension} />
          <FrozeDetailPhotoBlock dimensionItem={currentDimension} />
        </div>
      )}
    </div>
  )
}